import { useBurgerMenu } from "./hooks/useBurgerMenu";
import { BurgerMenuItem } from "../BurgerMenuItem";
import { VisibilityTransition } from "../VisibilityTransition";
import CloseIcon from "@/common/images/icons/x.svg?react";
import "./BurgerMenu.scss";
import { lazy, Suspense } from "react";

const MenuSocials = lazy(() => import("@/components/burger-menu-socials/MenuSocials"));

export const BurgerMenu = () => {
  const {
    handleCloseMenu,
    onSetActiveMenuItem,
    isBurgerMenuOpen,
    menuItems,
    activeMenuItem,
    handleDevModeClick
  } = useBurgerMenu();

  return (
    <VisibilityTransition active={isBurgerMenuOpen}>
      <div className="burgerMenuWrapper">
        <div className={`burgerMenu ${isBurgerMenuOpen ? "burgerMenuOpened" : "burgerMenuClosed"}`}>
          <div className="burgerMenuClose">
            <div className="devBtn" onTouchEnd={handleDevModeClick}></div>
            <button className="closeBtn" onClick={handleCloseMenu}><CloseIcon /></button>
          </div>
          <ul className="burgerMenuNav">
            {menuItems.map((item) => (
              <BurgerMenuItem key={item.title} onSetActiveMenuItem={onSetActiveMenuItem} activeMenuItem={activeMenuItem} {...item} />
            ))}
          </ul>
          <div className="burgerMenuFooter">
            <Suspense>
              <MenuSocials />
            </Suspense>
          </div>
        </div>
        <div className="overlay" onClick={handleCloseMenu} />
      </div>
    </VisibilityTransition>
  );
};
